<template>
  <div class="banner-bg">
    <div class="progress-text">
      Your Bundle Progress: ({{ selectedZoomerCount + selectedPanelCount }}/{{ zoomerQuantity + panelQuantity }} items selected)
    </div>
    <div class="slot-area">
      <div class="slot-group">
        <template v-for="i in zoomerQuantity" :key="'zoomer-' + i">
          <div class="slot-card slot-card-zoomer" :class="{ selected: i <= selectedZoomerCount }">
            <span class="slot-card-text">
              {{ i <= selectedZoomerCount ? selectedZoomerNames[i - 1] : "Select Zoomer" }}
            </span>
          </div>
          <div v-if="i < zoomerQuantity || panelQuantity > 0" class="slot-plus">+</div>
        </template>
        <template v-for="i in panelQuantity" :key="'panel-' + i">
          <div class="slot-card slot-card-panel" :class="{ selected: i <= selectedPanelCount }">
            <span class="slot-card-text">
              {{ i <= selectedPanelCount ? selectedPanelNames[i - 1] : "Select Panel" }}
            </span>
          </div>
          <div v-if="i < panelQuantity" class="slot-plus">+</div>
        </template>
      </div>
      <div class="price-area">
        <div class="bundle-price">Bundle Price: {{ currency.symbol }}{{ promoPrice.toFixed(2) }}</div>
        <div class="price-line">
          <span class="total-line">
            Total: {{ currency.symbol }}
            <span :class="{ 'line-through-value': totalPrice > 0 }">{{ totalPrice > 0 ? totalPrice.toFixed(2) : "——" }}</span>
          </span>
          <span class="price-divider">|</span>
          <span class="saved-line">Saved: {{ currency.symbol }}{{ savedAmount > 0 ? savedAmount.toFixed(2) : "——" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "BuildBundleBanner",
  props: {
    selectedZoomerCount: {
      type: Number,
      default: 0
    },
    selectedZoomerNames: {
      type: Array,
      default: () => []
    },
    selectedPanelCount: {
      type: Number,
      default: 0
    },
    selectedPanelNames: {
      type: Array,
      default: () => []
    },
    zoomerQuantity: {
      type: Number,
      default: 0
    },
    panelQuantity: {
      type: Number,
      default: 0
    },
    totalPrice: {
      type: Number,
      default: 0
    },
    savedAmount: {
      type: Number,
      default: 0
    },
    promoPrice: {
      type: Number,
      default: 0
    }
  },
  emits: [],
  computed: {
    ...mapState(["currency"]),
  }
};
</script>

<style scoped>
.banner-bg {
  background: var(--Warm-White, #fdf9f6);
  border: none;
  border-radius: 0;
  padding: 12px 16px;
}

.progress-text {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 20px;
  margin-bottom: 10px;
}

.slot-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.slot-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.slot-card {
  width: 180px;
  height: 72px;
  border-radius: 24px;
  border: 1px dashed #c4c4c4;
  background: #fff;
  color: #666;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slot-card-text {
  max-width: calc(100% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 18px;
  text-align: center;
}

.slot-card.slot-card-panel {
  width: 139px;
  text-align: center;
}

.slot-card.slot-card-zoomer.selected {
  border: 1px solid #004879;
  background: #004879;
  color: #fff;
  font-weight: 600;
}

.slot-card.slot-card-panel.selected {
  border: 1px solid #20a8c3;
  background: #20a8c3;
  color: #fff;
  font-weight: 500;
}

.slot-plus {
  color: #374957;
  font-size: 32px;
  line-height: 1;
  font-weight: 400;
}

.price-area {
  width: 338px;
  padding-left: 42px;
}

.bundle-price {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 20px;
}

.price-line {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.line-through-value {
  text-decoration: line-through;
}

.price-divider {
  color: #c4c4c4;
}

.saved-line {
  color: #588b8b;
}
</style>
